// MST
import { types, flow, cast } from 'mobx-state-tree'

import {
  IContactUsGetAttrs,
  IContactUsUpdateAttrs,
} from 'interfaces/back-office/content-management/contact-us/contact-us/contact-us-view.intercace'
import {
  IContactUsApiGetResponse,
  IContactUsApiUpdateResponse,
} from 'interfaces/back-office/content-management/contact-us/contact-us/contact-us-api.interface'
import { IContactUs } from 'interfaces/back-office/content-management/contact-us/contact-us'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'

// Contact Us Props
const contactUsProps = {
  title: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  phoneNumber: types.maybeNull(types.string),
  fax: types.maybeNull(types.string),
  email: types.maybeNull(types.string),
}

// Contact Us Model
const ContactUs = types.model('ContactUsDetail').props(contactUsProps)

const ContactUsStoreModel = types
  .model('HomeBanner')
  .props({
    contactUs_isLoading: types.optional(types.boolean, false),
    contactUs_isSaveLoading: types.optional(types.boolean, false),
    contactUs_detail: types.optional(ContactUs, {}),
  })
  .actions(self => ({
    contactUs_SET_LOADING: (payload: boolean): void => {
      self.contactUs_isLoading = payload
    },
    contactUs_SET_SAVE_LOADING: (payload: boolean): void => {
      self.contactUs_isSaveLoading = payload
    },
    contactUs_SET_DETAIL: (payload: IContactUs): void => {
      self.contactUs_detail = cast(payload)
    },
    contactUs_CLEAR_DETAIL: (): void => {
      self.contactUs_detail = cast({})
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Fetch contact us detail
     *
     * @param {IContactUsGetAttrs} payload
     *
     * @return {any} any
     */
    contactUs_fetch: flow(function* (payload: IContactUsGetAttrs) {
      self.contactUs_SET_LOADING(true)

      const response: IContactUsApiGetResponse = yield self.environment.contactUsApi.contactUs_get({
        body: { ...payload.body },
        requestConfig: { ...payload.requestConfig },
      })

      if (response.ok) {
        self.contactUs_SET_DETAIL(response.res.data)

        // Do when response success
        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        // Do when response failed

        if (payload?.onError) payload.onError()
      }

      self.contactUs_SET_LOADING(false)
    }),

    /**
     * @description Update contact us detail
     *
     * @param {IContactUsUpdateAttrs} payload
     *
     * @return {any} any
     */
    contactUs_update: flow(function* (payload: IContactUsUpdateAttrs) {
      self.contactUs_SET_SAVE_LOADING(true)

      const response: IContactUsApiUpdateResponse = yield self.environment.contactUsApi.contactUs_update({
        body: { ...payload.body },
        requestConfig: { ...payload.requestConfig },
      })

      if (response.ok) {
        // Do when response success
        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        // Do when response failed
        if (payload?.onError) payload.onError()
      }

      self.contactUs_SET_SAVE_LOADING(false)
    }),
  }))

export const createContactUsStoreDefaultModel = () => types.optional(ContactUsStoreModel, {})
